<div>
  <div>
    <div class="mb20">
      <span class="step-counter">Step {{1}}/{{3}}</span>
    </div>
    <div class="ds-input-wrap mb9 {{companyTypesForView}}">
      <h4>
          <span class="ds-input-label big mb20"><b>Please select your business type</b></span>
      </h4>
      <ds-dropdown
        [value]="selectedCompanyType"
        [smallSize]="true"
        [dsDropdownOptions]="companyTypesForView"
        [showDropDown]="false"
        [dsDropdownWithSearchIcon]="true"
        dsDropdownPlaceHolder="Search for your business or site type"
        [dsDropdownSearch]="true"
        [dsDropdownWithArrowIcon]="false"
        (onOptionChoose)="selectCompanyType($event)"
        (searchOutside)="searchCategory($event)"
      ></ds-dropdown>
    </div>
  </div>

  <div class="create-ai-assistant-form-view__action-wrap first-step {{nextIsTemplate}}">
   <div class="db-navigation-text">
     <span class="back-to-previous pr8" (click)="backToPreviousStep()">Back</span>
   </div>

    <button class="ds-btn-black rectangle"
            [ngClass]="{'ds-btn-disabled': !selectedCompanyType}"
            (click)="proceedToNextQuestion()"><span>Next</span>
    </button>

  </div>
</div>

<div class="create-ai-image-wrap">
  <div class="create-ai-image-1">
      <img src="assets/images/ai/onboarding/ai-informative-light.svg" alt="">
  </div>
  <div class="create-ai-image-2">
      <img src="assets/images/ai/onboarding/ai-informative-light-full.svg" alt="">
  </div>
</div>
